<template>
    <div class="content">
        <p class="subtitle is-5">{{"components.pages.login.pin.title" | translate}}</p>

        <form @submit.prevent="signIn">
            <!-- pincode -->
            <div class="field">
                <div class="control">
                    <input
                        v-model="code"
                        v-validate="`required|length:8`"
                        data-vv-name="code"
                        data-vv-validate-on="change"
                        @focus="clearServerErrors()"
                        :class="{'is-danger': errors.has('code')}"
                        class="input is-large"
                        type="text"
                        :placeholder="'components.pages.login.pin.pin placeholder' | translate"
                        autofocus
                        maxlength="50"
                        autocomplete="username"
                    />
                </div>
                <p
                    class="help is-danger"
                    v-if="errors.has('code:required')"
                >{{"components.pages.login.validation.code required" | translate}}</p>
                <p
                    class="help is-danger"
                    v-if="errors.has('code:length')"
                >{{"components.pages.login.validation.code length" | translate}}</p>
                <p
                    class="help is-danger"
                    v-if="errors.has('code', 'serverErrors')"
                >{{"components.pages.login.validation.pin activation error" | translate}}</p>
            </div>

            <!-- language -->
            <div v-if="availableLanguages.length > 1" class="is-inline-block login-language-block">
                <div class="field has-addons">
                    <p class="control">
                        <a class="button is-static">
                            <span class="icon"><i class="fas fa-globe"></i></span>
                        </a>
                    </p>
                    <div class="control">
                        <div class="select">
                            <select v-model="lang">
                                <option v-for="l in availableLanguages" :key="l" :value="l">{{langDescriptions[l]}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <!-- recaptcha -->
            <recaptcha
                v-show="false"
                ref="recaptcha"
                :on-response="response => { recaptchaResponse = response; }"
            />

            <!-- login button -->
            <div class="field">
                <button
                    class="button button-login is-large is-link"
                    :disabled="errors.any() || loading || !isRecaptchaVerified"
                >
                    <span v-if="!loading">{{"components.pages.login.login" | translate}}</span>
                    <span class="icon" v-if="loading">
                        <i class="fas fa-circle-notch fa-pulse"></i>
                    </span>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import Vue from 'vue';

import Recaptcha from '../../../common/recaptcha/recaptcha';

import authService from '../../../../../../_common/services/authentication.service';

export default {
    name: 'pin-login',
    $_veeValidate: { validator: 'new' },
    components: { Recaptcha },
    props: {
        success: {
            type: Function
        }
    },
    data() {
        return {
            loading: false,
            code: '',
            recaptchaResponse: null
        };
    },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        lang: {
            get() {
                return Vue.state.lang.currentLang;
            },
            set(val) {
                Vue.state.lang.currentLang = val;
            }
        },
        availableLanguages() {
            return Vue.state.lang.availableLanguages;
        },
        langDescriptions() {
            return Vue.state.lang.langDescriptions;
        },
        isRecaptchaVerified() {
            return !this.$refs.recaptcha || this.$refs.recaptcha.verified;
        }
    },
    methods: {
        hide() {
            this.resetFields();
        },
        resetFields() {
            this.code = '';
            this.failedAccessAttemptsLeft = null;
        },
        async signIn() {
            if (this.errors.any() || this.loading || !this.isRecaptchaVerified || !this.code) return;
            this.loading = true;
            this.errors.clear();
            const loginResult = await authService.pinLogin(this.$data.code);
            this.failedAccessAttemptsLeft = loginResult.failedAccessAttemptsLeft;
            if (loginResult.isSuccess) {
                await this.play();
            } else {
                this.errors.add({ field: 'code', rule: loginResult.error, msg: loginResult.error, scope: 'serverErrors' });
            }
            this.loading = false;
        },
        clearServerErrors() {
            this.errors.remove('code', 'serverErrors');
        },
        async play() {
            await Vue.state.player.reload();
            Vue.state.lang.ensureLocalLangOrPlayer(Vue.state.player.get().lang || 'ru');
            await Vue.router.teleport.home();
        }
    },
    beforeDestroy() {
        this.resetFields();
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/login/pin-login.vue